import React from 'react'
import { FormattedMessage } from 'react-intl'

export const PAGES = {
    leaderboards: 'leaderboards',
    craft: 'craft',
    boost: 'boost',
    rewards: 'rewards',
    bonuses: 'bonuses',
    battleSchedule: 'battleSchedule',
}

export const MENU_URLS = {
    [PAGES.leaderboards]: {
        url: '/leaderboards',
    },
    [PAGES.craft]: {
        url: '/craft/vehicles',
    },
    [PAGES.boost]: {
        url: '/boost',
    },
    [PAGES.bonuses]: {
        url: '/personal_shop/products',
    },
    [PAGES.rewards]: {
        url: '/personal_shop/rewards',
    },
    [PAGES.battleSchedule]: {
        url: '/battle_schedule',
    },
}

const CRAFT_TOOLTIP_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.craft.title"
        defaultMessage="Мастерская"
    />
)

const BOOST_TOOLTIP_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.boost.title"
        defaultMessage="Модернизация техники"
    />
)

const SHOP_TOOLTIP_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.shop.title"
        defaultMessage="Персональные бонусы"
    />
)

const REWARD_TOOLTIP_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.reward.title"
        defaultMessage="Награждение победителей"
    />
)

const BATTLE_SCHEDULE_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.battle_schedule.title"
        defaultMessage="Бои на Глобальной карте"
    />
)

const LEADERBOARDS_TITLE = (
    <FormattedMessage
        id="main_menu.tooltips.leaderboards.title"
        defaultMessage="Достижения в событии"
    />
)

export const SECTION_TOOLTIPS = {
    [PAGES.craft]: {
        title: CRAFT_TOOLTIP_TITLE,
    },
    [PAGES.boost]: {
        title: BOOST_TOOLTIP_TITLE,
    },
    [PAGES.rewards]: {
        title: REWARD_TOOLTIP_TITLE,
    },
    [PAGES.bonuses]: {
        title: SHOP_TOOLTIP_TITLE,
    },
    [PAGES.battleSchedule]: {
        title: BATTLE_SCHEDULE_TITLE,
    },
    [PAGES.leaderboards]: {
        title: LEADERBOARDS_TITLE,
    },
}



// WEBPACK FOOTER //
// ./containers/MainMenu/constants.jsx